import { Button, Grid, SvgIcon, Tab, Tabs } from '@mui/material';
import StockCountPage from './components/StockCountPage';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from '../../assets';
import { ActiveTab } from '../../enums/ActiveTab';
import { useNavigate } from 'react-router-dom';
import { UserContext } from './../../components/shared/useUser';
import PageArea from '../../components/shared/PageArea';
import { PageTitleWithButtons } from '../../components/shared/layout/PageTitleWithButtons';

const StockCount = () => {
  const [active, setActive] = useState<ActiveTab>(ActiveTab.Active);
  const { hasPermissionTo } = useContext(UserContext);
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const handleTabChange = (event: React.SyntheticEvent, newValue: ActiveTab) => {
    setActive(newValue);
  };
  const handleClick = () => {
    navigate('/store/create-stock-count');
  };

  return (
    <PageArea>
      <Grid container
        spacing={5}>
        <Grid item
          xs={12} >
          <PageTitleWithButtons title={t('stockcounts.title')}
            subTitle='Record and track your stock counts'>
            {hasPermissionTo(['StockCountWrite']) &&
              <Button size='lg'
                startIcon={<SvgIcon><Plus /></SvgIcon>}
                onClick={() => handleClick()} >{t('stockcounts.newitem')}</Button>}
          </PageTitleWithButtons>
        </Grid>
        <Grid item
          xs={12}>
          <Tabs value={active}
            onChange={handleTabChange}
            textColor="primary"
            indicatorColor="primary"
            aria-label="primary tabs example">
            <Tab label={t('active')}
              value={ActiveTab.Active} />
            <Tab label={t('archived')}
              value={ActiveTab.Inactive} />
          </Tabs>
        </Grid>
        <Grid item
          xs={12}>
          <StockCountPage activeTab={active}
            handleClick={handleClick} />
        </Grid>
      </Grid>
    </PageArea>
  );
};

export default StockCount;